export default __webpack_public_path__ + "static/media/gallery-6.3b590d66.jpg";